import { tApi } from "tplus-api";
import '../commom/Challenger';
import CutRetailDto from './CutRetailDto';

export default class BatchApi {
  /**
   * 获取可用量的接口
   */
  static async checkBatchDispatchForRE(dto) {
    
    if (!dto) {
      return;
    }
    let result = await tApi(
      {
        dto: CutRetailDto(dto)
      },
      "chanjet.AA.DR.INewRetailBaseInfo.CheckBatchDispatchForRE",
      false,
      false
    );

    return result;
  }
  static async getBatchDispatchForRE(params) {
    if (!params) {
      return;
    }
    let dto = CutRetailDto(params);
    console.log("GetBatchDispatchForRE---->请求对象", dto);
    let result = await tApi(
      {
        dto: dto
      },
      "chanjet.AA.DR.newRetailBaseInfo.GetBatchDispatchForRE",
      false,
      false
    );
    console.log("GetBatchDispatchForRE=====", result);
    return result;
  }
}
